import React from 'react';
import { Link } from 'react-router-dom';
import { categories } from './Category';
import styles from './CategoryList.module.css';

const CategoryList: React.FC = () => {
  return (
    <section id="kategorier" className="mt-5">
        <h2 className={styles['category-heading']}>Kategorier</h2>
        <div className="row g-4">
        {categories.map((category) => (
          <div className="col-md-4 mb-4" key={category.id}>
            <Link to={`/category/${category.slug}`} className="text-decoration-none">
              <div
                className="card h-100"
                style={{ display: 'flex', flexDirection: 'column', cursor: 'pointer', backgroundColor: 'rgba(248, 150, 165, 0.8)', borderRadius: '10px', boxShadow: 'inherit' }}
              >
                <div className="image-container" style={{ position: 'relative', paddingBottom: '100%', overflow: 'hidden' }}>
                  <img
                    src={category.image}
                    className="card-img-top"
                    alt={category.name}
                    style={{
                      position: 'absolute',
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      objectPosition: 'center',
                    }}
                  />
                </div>
                <div className="card-body" style={{ flex: '0 1 auto', display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                  <h3 className="card-title text-center" style={{borderRadius: '10px', padding: "0.5rem"}} >{category.name}</h3>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CategoryList;
